import Image from 'next/legacy/image';
import styles from './form-incut-status.module.scss';

type FormSubmitStatus = 'success' | 'failure';

interface FormSubmitStatusProps {
  status: FormSubmitStatus;
}

const TITLES = new Map<FormSubmitStatus, string>([
  ['success', 'Application sent'],
  ['failure', 'Application not sent'],
]);

const ICONS = new Map<FormSubmitStatus, string>([
  ['success', '/assets/icons/icn-success.svg'],
  ['failure', '/assets/icons/icn-error.svg'],
]);

const TEXT = new Map<FormSubmitStatus, string>([
  ['success', 'Thank you! Your checklist in on the way to your email.'],
  ['failure', 'Unfortunately, something went wrong. Please try again later.'],
]);

export default function FormIncutStatus({ status }: FormSubmitStatusProps) {
  console.log(status);
  return (
    <div className={styles.container}>
      <div className={`${styles.icon}  ${status === 'success' ? styles.success : styles.error}`}>
        <Image alt="image" width="24" height="18" src={ICONS.get(status)!} />
      </div>
      <div className={styles.title}>{TITLES.get(status)!}</div>
      <div className={styles.text}>{TEXT.get(status)!}</div>
    </div>
  );
}
